import React from 'react';

const GenerateButton = ({ canGenerate, onClick, status }) => {
  const { loading, success } = status || {};
  const label = loading
    ? 'Generando...'
    : success
      ? 'Pronóstico Generado'
      : canGenerate
        ? 'Generar pronóstico'
        : 'Configura los parámetros';
  const icon = loading ? 'loader' : success ? 'check-circle' : 'trending-up';

  return (
    <button
      id="generateBtn"
      className={`primary-action-btn${loading ? ' btn-loading' : ''}${success ? ' btn-success' : ''}`}
      disabled={!canGenerate || loading}
      onClick={onClick}
    >
      <span className="btn-icon">
        <i data-lucide={icon} />
      </span>
      <span className="btn-text">{label}</span>
    </button>
  );
};

export default GenerateButton;
